import { render, staticRenderFns } from "./CardEmploymentPoliciesManagement.vue?vue&type=template&id=224223de&scoped=true&"
import script from "./CardEmploymentPoliciesManagement.vue?vue&type=script&lang=js&"
export * from "./CardEmploymentPoliciesManagement.vue?vue&type=script&lang=js&"
import style0 from "./CardEmploymentPoliciesManagement.vue?vue&type=style&index=0&id=224223de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224223de",
  null
  
)

export default component.exports